/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  Multicall2,
  Multicall2Interface,
} from "../../../contracts/multicall/Multicall2";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
        ],
        internalType: "struct Multicall2.Call[]",
        name: "calls",
        type: "tuple[]",
      },
    ],
    name: "aggregate",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
      {
        internalType: "bytes[]",
        name: "returnData",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
        ],
        internalType: "struct Multicall2.Call[]",
        name: "calls",
        type: "tuple[]",
      },
    ],
    name: "blockAndAggregate",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "success",
            type: "bool",
          },
          {
            internalType: "bytes",
            name: "returnData",
            type: "bytes",
          },
        ],
        internalType: "struct Multicall2.Result[]",
        name: "returnData",
        type: "tuple[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    name: "getBlockHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getBlockNumber",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCurrentBlockCoinbase",
    outputs: [
      {
        internalType: "address",
        name: "coinbase",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCurrentBlockDifficulty",
    outputs: [
      {
        internalType: "uint256",
        name: "difficulty",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCurrentBlockGasLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "gaslimit",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCurrentBlockTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "getEthBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLastBlockHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "requireSuccess",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
        ],
        internalType: "struct Multicall2.Call[]",
        name: "calls",
        type: "tuple[]",
      },
    ],
    name: "tryAggregate",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "success",
            type: "bool",
          },
          {
            internalType: "bytes",
            name: "returnData",
            type: "bytes",
          },
        ],
        internalType: "struct Multicall2.Result[]",
        name: "returnData",
        type: "tuple[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "requireSuccess",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
        ],
        internalType: "struct Multicall2.Call[]",
        name: "calls",
        type: "tuple[]",
      },
    ],
    name: "tryBlockAndAggregate",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "success",
            type: "bool",
          },
          {
            internalType: "bytes",
            name: "returnData",
            type: "bytes",
          },
        ],
        internalType: "struct Multicall2.Result[]",
        name: "returnData",
        type: "tuple[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type Multicall2ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: Multicall2ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Multicall2__factory extends ContractFactory {
  constructor(...args: Multicall2ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Multicall2> {
    return super.deploy(overrides || {}) as Promise<Multicall2>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): Multicall2 {
    return super.attach(address) as Multicall2;
  }
  override connect(signer: Signer): Multicall2__factory {
    return super.connect(signer) as Multicall2__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): Multicall2Interface {
    return new utils.Interface(_abi) as Multicall2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Multicall2 {
    return new Contract(address, _abi, signerOrProvider) as Multicall2;
  }
}
